"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeLoanSchema = void 0;
exports.activeLoanSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'cmhcAccountNumber',
        'accountStatusOverrideReasonText',
        'accountStatusTypeCode',
        'administeringLenderID',
        'advancePremiumProcessedIndicator',
        'annualShelterPaymentAmount',
        'applicantTypeCode',
        'applicationReceivedMethodTypeCode',
        'applicationSourceTypeCode',
        'approvedLenderID',
        'builderLoanTypeCode',
        'builderTypeCode',
        'bulkAccountIndicator',
        'certificateLastPrintTime',
        'cmhcFeesDueAmount',
        'cmhcFeesReceivedAmount',
        'cmhcOfficeID',
        'costableUnitID',
        'currentCertificatesFaxCount',
        'currentCertificatesPrintedCount',
        'feeAmountOverrideIndicator',
        'feeDueOverrideReasonTypeCode',
        'feeProvincialSalesTaxPayableAmount',
        'feeProvincialSalesTaxReceivedAmount',
        'feesChargedLoanAmount',
        'feesChargedLoanAmountIndicator',
        'finalLoanAdvanceIndicator',
        'financialInstitutionID',
        'financialInstitutionTransitNumber',
        'fundsTypeCode',
        'grossDebtServiceRatioPercent',
        'guarantorName',
        'installmentCompletionTypeCode',
        'interestTypeCode',
        'lenderLoanAmount',
        'lenderLoanNumber',
        'lendingValueOverrideIndicator',
        'loanAdvanceHoldbackAmount',
        'loanAdvanceHoldbackTypeCode',
        'loanAmortizationPeriod',
        'loanInterestRate',
        'loanPurposeTypeCode',
        'loanRiskLevelTypeCode',
        'loanSecurityTypeCode',
        'loanSpecialConditionIndicator',
        'loanSpecialConditionMetIndicator',
        'loanTermPeriod',
        'loanToValueRatioPercent',
        'lowRatioApplicationInsurableIndicator',
        'marketTypeCode',
        'marketValueImprovedAmount',
        'missingDocumentsIndicator',
        'mliPremiumDueAmount',
        'mliPremiumPercent',
        'mliPremiumReceivedAmount',
        'mortgageInsurancePremiumProvincialSalesTaxPayableAmount',
        'mortgageInsurancePremiumProvincialSalesTaxReceivedAmount',
        'mortgageRepaymentTypeCode',
        'nationalHousingActSectionNumber',
        'nonRefundableAmount',
        'otherFinancingAmount',
        'premiumAmountOverrideIndicator',
        'premiumChargedLoanAmount',
        'premiumChargedLoanIndicator',
        'premiumDueOverrideReasonTypeCode',
        'premiumOverrideReasonAmount',
        'premiumTaxOverrideIndicator',
        'productTrackerID',
        'propertyLendingValue',
        'propertyMarketValueAmount',
        'propertySellingPriceAmount',
        'qualityAssuranceIndicator',
        'registeredRetirementSavingsPlanDownPaymentAmount',
        'rejectReasonTypeCodeDescription',
        'seniorUnderwriterID',
        'seniorUnderwriterOfficeID',
        'serviceTypeCode',
        'statisticalDataAvailableIndicator',
        'systemReceivedTime',
        'totalBorrowerIncomeAmount',
        'totalDebtServiceRatioPercent',
        'totalFamilyAnnualIncomeAmount',
        'totalInsurableLoanAmount',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        accountStatusOverrideReasonText: {
            type: 'string',
            minLength: 0,
            maxLength: 80,
            errorMessage: 'should have variable length up to 80 characters',
        },
        accountStatusTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        administeringLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        advancePremiumProcessedIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        annualShelterPaymentAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        applicantTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        applicationApprovedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationApprovedSystemDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationAutomaticCancellationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationCancelledDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationReceivedMethodTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        applicationReceivedSystemDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationReinstatementDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationRejectedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationSourceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        applicationWithdrawnDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        approvedLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        builderLoanTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        builderTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        bulkAccountIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        certificateLastPrintTime: {
            type: 'string',
            pattern: '^(\\d{1,2})(\\.|:)(\\d{2})(\\.|:)(\\d{1,2}|f\\d)$',
            errorMessage: 'should have time format 00.00.00 or 00.00.f0',
        },
        cmhcFeesDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        cmhcFeesReceivedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        cmhcOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        completedDocumentationReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        costableUnitID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        currentCertificatesFaxCount: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        currentCertificatesPrintedCount: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        feeAmountOverrideIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        feeDueOverrideReasonTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        feeProvincialSalesTaxPayableAmount: {
            type: 'number',
            maximum: 999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 11 digits in total and 2 digits of precision',
        },
        feeProvincialSalesTaxReceivedAmount: {
            type: 'number',
            maximum: 999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 11 digits in total and 2 digits of precision',
        },
        feeProvincialSalesTaxReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        feesChargedLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        feesChargedLoanAmountIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        finalLoanAdvanceIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        financialInstitutionID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        financialInstitutionTransitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        firstCertificatePrintedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        fundsTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        grossDebtServiceRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            multipleOf: 0.00009999999999999999,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        guarantorName: {
            type: 'string',
            minLength: 0,
            maxLength: 35,
            errorMessage: 'should have variable length up to 35 characters',
        },
        installmentCompletionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        interestTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        lastCertificatePrintDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        lastFeeReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        lastPremiumReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        lenderLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        lenderLoanNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        lendingValueOverrideIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanAdvanceHoldbackAmount: {
            type: 'number',
            maximum: 999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 11 digits in total and 2 digits of precision',
        },
        loanAdvanceHoldbackTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        loanAmortizationPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        loanFinalizationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        loanInterestRate: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.00009999999999999999,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        loanPurposeTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanRiskLevelTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanSecurityTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanSpecialConditionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanSpecialConditionMetIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanTermPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        loanToValueRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 5 digits in total and 2 digits of precision',
        },
        lowRatioApplicationInsurableIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        marketTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        marketValueImprovedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        missingDocumentsIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        mliPolicyIssueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mliPolicyTerminationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mliPremiumDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mliPremiumPercent: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.00009999999999999999,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        mliPremiumReceivedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mortgageInsurancePremiumProvincialSalesTaxPayableAmount: {
            type: 'number',
            maximum: 999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 11 digits in total and 2 digits of precision',
        },
        mortgageInsurancePremiumProvincialSalesTaxReceivedAmount: {
            type: 'number',
            maximum: 999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 11 digits in total and 2 digits of precision',
        },
        mortgageInsurancePremiumProvincialSalesTaxReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mortgageRepaymentTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        nationalHousingActSectionNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        nonRefundableAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        otherFinancingAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        premiumAmountOverrideIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        premiumChargedLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        premiumChargedLoanIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        premiumDueOverrideReasonTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        premiumOverrideReasonAmount: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        premiumTaxOverrideIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        productTrackerID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        propertyLendingValue: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        propertyMarketValueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        propertySellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        qualityAssuranceIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        registeredRetirementSavingsPlanDownPaymentAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        rejectReasonTypeCodeDescription: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        riskEffectiveDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        seniorUnderwriterID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        seniorUnderwriterOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        serviceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        statisticalDataAvailableIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        systemReceivedTime: {
            type: 'string',
            pattern: '^(\\d{1,2})(\\.|:)(\\d{2})(\\.|:)(\\d{1,2})$',
            errorMessage: 'should have time format 00.00.00',
        },
        totalBorrowerIncomeAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        totalDebtServiceRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.00009999999999999999,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        totalFamilyAnnualIncomeAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        totalInsurableLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
    },
};
